import server from "./server";

export const getContactsApi = async () => {
  const response = await server().get("/contacts");
  return response.data;
};

export const getContactApi = async ({ id }) => {
  const response = await server().get(`/contacts/${id}`);
  return response.data;
};

export const deleteContactApi = async (id) => {
  const response = await server().delete(`/contacts/${id}`);

  return response.data;
};
